import "./footer.css";

import React from "react";
import { Link } from "react-router-dom";

import { CONTACT_DETAILS, ROUTES, SITE_NAME } from "../../data/content";
import { FacebookIcon, InstagramIcon } from "../general/Icons";

const Footer = () => {
  return (
    <footer className={"site-footer"}>
      <div className={"site-footer-inner"}>
        <Link
          to={ROUTES.HOME}
          className={"footer-logo"}
          aria-label={"Graylag & Co - home"}
        >
          <img
            src={"/images/logo-white.png"}
            alt={""}
            width={916}
            height={152}
            loading={"lazy"}
          />
        </Link>

        <h2 className={"footer-heading"}>Location</h2>
        <address className={"footer-address"}>
          <a
            href={CONTACT_DETAILS.MAP_LINK}
            target={"_blank"}
            rel={"noopener noreferrer"}
          >
            {CONTACT_DETAILS.ADDRESS.map((line) => (
              <React.Fragment key={line}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </a>
        </address>

        <p className={"footer-copyright"}>
          © {new Date().getFullYear()} by {SITE_NAME}, created by{" "}
          <a
            href={CONTACT_DETAILS.CREDIT.link}
            target={"_blank"}
            rel={"noopener noreferrer"}
          >
            {CONTACT_DETAILS.CREDIT.label}
          </a>
        </p>

        <ul className={"footer-social"}>
          <li>
            <a
              href={CONTACT_DETAILS.FACEBOOK_LINK}
              target={"_blank"}
              rel={"noopener noreferrer"}
              aria-label={"Graylag & Co on Facebook"}
            >
              <FacebookIcon />
            </a>
          </li>
          <li>
            <a
              href={CONTACT_DETAILS.INSTAGRAM_LINK}
              target={"_blank"}
              rel={"noopener noreferrer"}
              aria-label={"Graylag & Co on Instagram"}
            >
              <InstagramIcon />
            </a>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
